import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";

var root = $.from_html(`<div> </div>`);

export default function Text($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	const color = $.derived(() => $.get(p).color == null || $.get(p).color === "" ? undefined : text($.get(p).color));
	const size = $.derived(() => cssLength($.get(p).size));

	function cssLength(value) {
		if (value == null || value === "") return undefined;

		const rendered = text(value);

		return (/^-?\d+(\.\d+)?$/).test(rendered) ? `${rendered}px` : rendered;
	}

	var div = root();
	let styles;
	var text_1 = $.child(div, true);

	$.reset(div);

	$.template_effect(
		($0, $1) => {
			$.set_class(div, 1, $0);
			styles = $.set_style(div, '', styles, { color: $.get(color), 'font-size': $.get(size) });
			$.set_text(text_1, $1);
		},
		[
			() => `slex-text${$.get(p).variant ? ` slex-text--${text($.get(p).variant)}` : ""}${$.get(p).class ? ` ${text($.get(p).class)}` : ""}`,
			() => text($.get(p).content ?? $.get(p).text ?? $.get(p).label)
		]
	);

	$.append($$anchor, div);
	$.pop();
}